// extracted by mini-css-extract-plugin
export default {"container":"pB-z","heading":"qB-z","text":"rB-z","info":"sB-z","link":"tB-z","fullMaxWidth":"uB-z"};